/**
 * The tones a toast can take. Each one says how the action went, and decides
 * whether the toast goes away on its own: only good news does.
 */
export const TOAST_TONE = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  PROGRESS: 'progress',
};

/**
 * Tones that stay until the user closes them. An error or a warning closing on
 * its own is one the user can miss, and a progress toast is replaced by its
 * outcome rather than timed out.
 */
export const STICKY_TONES = [TOAST_TONE.ERROR, TOAST_TONE.WARNING, TOAST_TONE.PROGRESS];

/** How long good news stays: the same 6 s the old `Notice` gave every message. */
export const TOAST_DURATION_MS = 6000;

/** More than this and the stack starts covering the page it reports on. */
export const MAX_TOASTS = 4;

/** The handle of a toast that brings no `testId` of its own. */
export const DEFAULT_TOAST_TEST_ID = 'toast';

/**
 * What a toast's button does. Plain data, because the toast lives in Redux and
 * a callback would not survive the serializable check; `FeedbackHost` turns
 * each kind into the actual call.
 */
export const TOAST_ACTION = {
  NAVIGATE: 'navigate',
  OPEN_ACTIVITY: 'openActivity',
  OPEN_URL: 'openUrl',
};
